/** Build a portal invite URL from an invite code. */
export function buildInviteLink(inviteCode: string | undefined): string {
  if (!inviteCode) {
    return '';
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/invite/${encodeURIComponent(inviteCode)}`;
  }
  return `/invite/${encodeURIComponent(inviteCode)}`;
}
